import { Costcenter } from '../../models/costcenter.model';

export function formatCostcenterLabel(costcenter: Costcenter): string {
  return `${costcenter.description} (${costcenter.external_id})`;
}
